import serializeQueryParams from './serializeQueryParams';

export default ($axios) => ({
  async notifiers(userId, queryParams = null) {
    let params = queryParams ? '?' + serializeQueryParams(queryParams) : '';

    return await $axios.get(`/users/${userId}/notifiers` + params);
  },
})